module.exports = __webpack_public_path__ + "images/emoji/leftwards_arrow_with_hook.25305ad538385d19f0a8.png";